import React from 'react';
import { PortfolioChart } from '../portfolio-chart';
import Modal2 from 'components/commons/modal/Modal2';
import { commaFormat } from 'components/features/new-report/utils/formatter';
import {
  ManagementType,
  PortfolioAnalysisItem,
} from 'components/features/target-achievement-support/utils/type';
import {
  getManagementItemInfo,
  portfolioTypeToBackgroundColor,
  portfolioTypeToString,
} from 'components/features/target-achievement-support/utils/portfolioInfo';

export const SettingManagementTypeModal = ({
  isShow,
  hide,
  portfolios,
  initialManagementType,
}: {
  isShow: boolean;
  hide: () => void;
  portfolios: PortfolioAnalysisItem[] | undefined;
  initialManagementType: ManagementType;
}): React.ReactElement => {
  const managementItemInfo = getManagementItemInfo(initialManagementType);
  if (managementItemInfo === undefined || portfolios === undefined)
    return <></>;

  const dispInitialPortfolios = portfolios.filter(
    portfolios => portfolios.assetType !== 'OTHER'
  );

  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4">
          <div className="flex flex-row">
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="text-sm text-center text-teal-500">
            今の設定中アセット
          </div>
          <div className="flex flex-row justify-center items-center">
            <div className="">
              <img
                style={{ width: '30px', height: '30px' }}
                src={`/static/images/advisor/asset_icon/${managementItemInfo.imgName}.svg`}
                alt="アイコン"
              />
            </div>
            <div className="ml-2 font-bold text-base">
              <span className={`${managementItemInfo.titleColor}`}>
                {managementItemInfo.title}
              </span>
              {managementItemInfo.subTitle}
            </div>
          </div>
          <div className={`flex justify-center`}>
            <div className="flex flex-row">
              <div className="flex flex-col justify-center">
                <PortfolioChart
                  {...{
                    chart: {
                      title: '',
                    },
                    data: dispInitialPortfolios.map(p => {
                      return {
                        id: p.assetType,
                        value: p.targetPer,
                      };
                    }),
                    idToColor: portfolioTypeToBackgroundColor,
                    idToTitle: portfolioTypeToString,
                    valueFormatter: value =>
                      commaFormat(value, { numberOfDecimals: 0 }),
                  }}
                />
              </div>
              <div className="flex-col flex items-center">
                <div
                  className="flex flex-col p-4 gap-2"
                  style={{ minHeight: '155px' }}>
                  {dispInitialPortfolios.map((p, key) => {
                    return (
                      <div className="flex flex-row items-center" key={key}>
                        <div
                          className="rounded-full w-3 h-3"
                          style={{
                            backgroundColor: portfolioTypeToBackgroundColor(
                              p.assetType
                            ),
                          }}></div>
                        <div className="ml-2 mr-6 text-xs whitespace-no-wrap">
                          {portfolioTypeToString(p.assetType)}
                        </div>
                        <div className="ml-auto text-xs">
                          {commaFormat(p.targetPer, {
                            numberOfDecimals: 1,
                          })}
                          %
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="flex justify-center text-gray-500 mb-3 mx-1 p-2 text-sm cursor-pointer"
          onClick={hide}>
          閉じる
        </div>
      </Modal2>
    </>
  );
};
